import { render, staticRenderFns } from "./OrderNewComponent.vue?vue&type=template&id=37780159"
import script from "./OrderNewComponent.vue?vue&type=script&lang=js"
export * from "./OrderNewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports